module.exports = __webpack_public_path__ + "media/images/pic/anime/romper-shadow-c6d8c92576a6587afcac0d8a4653ba06.svg";